import Vue from 'vue';
import 'vue-croppa/dist/vue-croppa.css';
import Croppa from 'vue-croppa';

Vue.use(Croppa);
